export default __webpack_public_path__ + "static/media/Home-Page.4a929b71.jpg";